import React from "react";
import { Link } from "react-router-dom";
import AuthPage from "../../components/auth/AuthPage";
import { Button } from "../../components/ui/button";

const AuthOnboarding = () => {
  return (
    <AuthPage
      title="Sign Up"
      description="Do you have a DeeXoptions account?"
    >
      <div className="flex flex-col gap-4 mds:flex-row">
        <Button
          asChild
          variant="outline"
          className="h-[48px] flex-1 rounded-xl border-primary text-[15px] font-semibold text-primary hover:bg-accent hover:text-primary"
        >
          <Link to="/signup">No, create an account</Link>
        </Button>
        <Button
          asChild
          className="h-[48px] flex-1 rounded-xl text-[15px] font-semibold"
        >
          <Link to="/login">Yes, I have an account</Link>
        </Button>
      </div>
    </AuthPage>
  );
};

export default AuthOnboarding;
